module.exports = __webpack_public_path__ + "static/media/Skyline.081505d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/about/Skyline.jpg
// module id = 469
// module chunks = 0